import { Injectable } from "@angular/core";
import { Applicant, XeroOAuthDTO } from "../models/data-model";
import { RegistrationApiService } from "./registration-api.service";
import { SoldoCookieService } from "./soldo-cookie.service";

export interface XeroStatus {
    status: 'None' | 'Start' | 'Auth';
    code?: string;
    state?: string;
    reference?: string;
}

@Injectable({
    providedIn: 'root'
})
export class XeroIntegrationService {
    private applicant: Applicant;


    constructor(
        private readonly cookieService: SoldoCookieService,
        private readonly registrationApiService: RegistrationApiService,
    ) {}


    getXeroStatus(url: URL): XeroStatus {
        const flowStarted: boolean = this.hasSearchParam(url, "SignupWithXero");
        const code: string = this.getSearchParam(url, "code");
        const state: string = this.getSearchParam(url, "state");
        const reference: string = this.cookieService.readSignupWithXeroReferenceCookie();
        const authorized: boolean = Boolean(code) && Boolean(state) && Boolean(reference);
        let status: 'None' | 'Start' | 'Auth' = 'None';
        if (flowStarted) {
            status = 'Start';
        } else if (authorized) {
            status = 'Auth';
        }
        return {
            status: status,
            code: code,
            state: state,
            reference: reference
        }
    }

    start(): Promise<XeroOAuthDTO> {
        return this.registrationApiService.xeroInitSignup()
            .then(data => {
                this.cookieService.writeSignupWithXeroReferenceCookie(data.reference);
                return data;
            })
    }

    getData(dto: XeroOAuthDTO): Promise<Applicant> {
        return this.registrationApiService.xeroGetUserData(dto)
            .then(applicant => {
                this.applicant = applicant;
                return applicant;
            });
    }

    getApplicant(): Applicant {
        return this.applicant;
    }

    private getSearchParam(urlObject: URL, key: string): string {
        if (urlObject?.searchParams) {
            const value = urlObject.searchParams.get(key);
            return value === "" ? null : value;
        }
        return null;
    }

    private hasSearchParam(urlObject: URL, key: string): boolean {
        let value = false;
        if (urlObject?.searchParams) {
            value = urlObject.searchParams.has(key);
        }
        return value;
    }
}
